var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNozzle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.769,
    height: 48.236,
    viewBox: "0 0 58.769 48.236",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_23",
    "data-name": "Gruppe 23",
    transform: "translate(-1204 -1175.264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_21",
    "data-name": "Gruppe 21",
    transform: "translate(1283.4 1169.264)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_17",
    "data-name": "Rechteck 17",
    width: 27.304,
    height: 3.034,
    transform: "translate(-79.4 18.135)",
    fill: "#bcb243"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_18",
    "data-name": "Rechteck 18",
    width: 27.304,
    height: 3.034,
    transform: "translate(-79.4 6)",
    fill: "#bcb243"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_19",
    "data-name": "Rechteck 19",
    width: 11.268,
    height: 3.034,
    transform: "translate(-79.4 12.067)",
    fill: "#bcb243"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_20",
    "data-name": "Rechteck 20",
    width: 12.048,
    height: 3.034,
    transform: "translate(-64.144 12.067)",
    fill: "#bcb243"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_21",
    "data-name": "Rechteck 21",
    width: 27.304,
    height: 3.034,
    transform: "translate(-47.935 18.135)",
    fill: "#bcb243"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_22",
    "data-name": "Rechteck 22",
    width: 27.304,
    height: 3.034,
    transform: "translate(-79.4 24.202)",
    fill: "#bcb243"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_23",
    "data-name": "Rechteck 23",
    width: 27.304,
    height: 3.034,
    transform: "translate(-47.935 24.202)",
    fill: "#bcb243"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_24",
    "data-name": "Rechteck 24",
    width: 27.304,
    height: 3.034,
    transform: "translate(-47.935 6)",
    fill: "#bcb243"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_25",
    "data-name": "Rechteck 25",
    width: 27.304,
    height: 3.034,
    transform: "translate(-47.935 12.067)",
    fill: "#bcb243"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_22",
    "data-name": "Gruppe 22",
    transform: "translate(1183.369 1229.5) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_17-2",
    "data-name": "Rechteck 17",
    width: 27.304,
    height: 3.034,
    transform: "translate(-79.4 18.135)",
    fill: "#bcb243"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_18-2",
    "data-name": "Rechteck 18",
    width: 27.304,
    height: 3.034,
    transform: "translate(-79.4 6)",
    fill: "#bcb243"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_19-2",
    "data-name": "Rechteck 19",
    width: 11.268,
    height: 3.034,
    transform: "translate(-79.4 12.067)",
    fill: "#bcb243"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_20-2",
    "data-name": "Rechteck 20",
    width: 12.048,
    height: 3.034,
    transform: "translate(-64.144 12.067)",
    fill: "#bcb243"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_21-2",
    "data-name": "Rechteck 21",
    width: 27.304,
    height: 3.034,
    transform: "translate(-47.935 18.135)",
    fill: "#bcb243"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_22-2",
    "data-name": "Rechteck 22",
    width: 27.304,
    height: 3.034,
    transform: "translate(-79.4 24.202)",
    fill: "#bcb243"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_23-2",
    "data-name": "Rechteck 23",
    width: 27.304,
    height: 3.034,
    transform: "translate(-47.935 24.202)",
    fill: "#bcb243"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_24-2",
    "data-name": "Rechteck 24",
    width: 27.304,
    height: 3.034,
    transform: "translate(-47.935 6)",
    fill: "#bcb243"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_25-2",
    "data-name": "Rechteck 25",
    width: 27.304,
    height: 3.034,
    transform: "translate(-47.935 12.067)",
    fill: "#bcb243"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNozzle);
export default __webpack_public_path__ + "static/media/icon-nozzle.0fe10c401f43de751ad682ea32878672.svg";
export { ForwardRef as ReactComponent };